// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8dIyJ","selected":"styles_selected__3ELvZ"};